import { useContext } from "react";
import QuotationsContext from "../contexts/_DEPRECATED";

export function useQuotations() {
  const quotationsContext = useContext(QuotationsContext);

  return quotationsContext;
}
